<template>
	<card header-classes="bg-dark">
		<template slot="header">
			<h3 class="mb-0 text-white">ตั้งค่าเติมเงินทรูมันนี่วอลเล็ทด้วย อังเปา</h3>
		</template>
		<template>
			<form @submit.prevent="saveSetting">
				<base-input label="ชื่อบัญชี" placeholder="ชื่อบัญชี" v-model="data.accountName" />
				<base-input label="เบอร์โทรศัพท์" placeholder="เบอร์โทรศัพท์" v-model="data.phoneNumber" />

				<div class="mt-3">
					<base-button native-type="submit" type="default" :disabled="loading">
						บันทึกข้อมูล
					</base-button>
				</div>
			</form>
		</template>
	</card>
</template>

<script>
import { Select, Option } from 'element-ui'

import api from '../../services'
import { mapState, mapGetters } from "vuex";

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	computed: {
    ...mapGetters("auth", ["truewalletVoucher"])
  },
	data() {
		return {
			loading: false,
			data: {
				accountName: '',
				phoneNumber: '',
			},
		}
	},
	methods: {
		async saveSetting() {
			this.loading = true

			try {
				const res = await api.patch('/truewallet-voucher', this.data)

				this.$notify({
					type: 'success',
					message: res.message,
				})
			} catch ({ message }) {
				this.$notify({
					type: 'danger',
					message: message,
				})
			} finally {
				this.loading = false
			}
		},
	},
	async created() {
		this.data.accountName = this.truewalletVoucher?.accountName
		this.data.phoneNumber = this.truewalletVoucher?.phoneNumber
		// try {
		// 	const res = await api.get('/setting/website')

		// 	console.log(res.data)
		// 	this.data = res.data
		// } catch ({ message }) {
		// 	this.$notify({
		// 		type: 'danger',
		// 		message: message,
		// 	})
		// }	
	},
}
</script>
